<template>
    <vs-card :style="'min-width: '+width+'px;min-height: '+height+'px;'">
        <div slot="header" class="text-center">
                <span>
                        <h3 style="display:inline-block; white-space: pre;">{{ title }}</h3>
                        <vx-tooltip v-if="tooltiptext" style="display:inline-block;" class="ml-2" :text="tooltiptext">
                            <div style="background-color: rgb(195, 195, 195); border-radius: 50%; width: 32px; height: 32px; color: white; text-align: center !important;"><div class="pt-2">?</div></div>
                        </vx-tooltip>
                </span>
        </div>
        <div class="vx-row justify-center">
            <div class="vx-col">
                <vs-chip><strong style="font-size: 24px;">{{ statistics }}</strong></vs-chip>
            </div>
        </div>
        <div class="vx-row justify-center hvr">
            <span>
                <vs-avatar v-if="icon && emithandler" icon-pack="feather" :icon="icon" size="small" :color="color" class="hvr-shadow" style="cursor: pointer !important;" @click="$emit(emithandler)"></vs-avatar>
                <vs-avatar v-else-if="icon" icon-pack="feather" :icon="icon" size="small" :color="color" style="cursor: default !important;"></vs-avatar>
                <vs-avatar v-else-if="icontext && emithandler" :text="icontext" size="small" :color="color" class="hvr-shadow" style="font-size: 24px; cursor: pointer !important;" @click="$emit(emithandler)"></vs-avatar>
                <vs-avatar v-else :text="icontext" size="small" :color="color" style="font-size: 24px; cursor: default !important;"></vs-avatar>
            </span>
            <span v-if="nosign == true && emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">{{ value }} {{ valtext }}</span>
            <span v-else-if="nosign == true" style="font-size: 18px;" class="pt-2">{{ value }} {{ valtext }}</span>

            <span v-else-if="invertval == true && value < 0  && emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">+{{ value * -1 }} {{ valtext }}</span>
            <span v-else-if="invertval == true && value < 0" style="font-size: 18px;" class="pt-2">+{{ value * -1 }} {{ valtext }}</span>
            <span v-else-if="invertval == true && value > 0  && emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">-{{ value }} {{ valtext }}</span>
            <span v-else-if="invertval == true && value > 0" style="font-size: 18px;" class="pt-2">-{{ value }} {{ valtext }}</span>

            <span v-else-if="invertval == false && value < 0  && emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">{{ value }} {{ valtext }}</span>
            <span v-else-if="invertval == false && value < 0" style="font-size: 18px;" class="pt-2">{{ value }} {{ valtext }}</span>
            <span v-else-if="invertval == false && value > 0  && emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">+{{ value }} {{ valtext }}</span>
            <span v-else-if="invertval == false && value > 0" style="font-size: 18px;" class="pt-2">+{{ value }} {{ valtext }}</span>

            <span v-else-if="emithandler" style="font-size: 18px;" class="pt-2 hvr-underline" @click="$emit(emithandler)">{{ value }} {{ valtext }}</span>
            <span v-else style="font-size: 18px;" class="pt-2">{{ value }} {{ valtext }}</span>
        </div>
    </vs-card>
</template>

<script>
export default {
	name: "ReportCard",
	props: {
		width: {
			type: Number,
			default: 250
		},
		height: {
			type: Number,
			default: 140
		},
		color: {
			type: String,
			default: ""
		},
		icon: {
			type: String,
			default: ""
		},
		icontext: {
			type: String,
			default: ""
		},
		statistics: {
			type: [Number, String],
			default: 0
		},
		value: {
			type: [Number, String],
			default: 0
		},
		valtext: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		tooltiptext: {
			type: String,
			default: null,
		},
		invertval: {
			type: Boolean,
			default: false
		},
		nosign: {
			type: Boolean,
			default: false
		},
		emithandler: {
			type: String,
			default: null
		}
	}

};
</script>

<style lang="scss" scoped>
.hvr span .hvr-underline-out{
    color: black;
}
.hvr:hover .hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.hvr:hover .hvr-shadow:hover{
    box-shadow: 0px 0px 8px 2px #0ff;
}
/* .hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.hvr-shadow:hover{
    box-shadow: 0px 0px 8px 2px #0ff;
} */
</style>